'use strict';

require('@firebase/auth-compat');

//# sourceMappingURL=index.cjs.js.map
